export default "__VITE_ASSET__c837599b__"